import Info from "../Info";

export default function SecondBox({
  tSelfAssist,
  showValidationErrors,
  validationErrors,
  assistant,
  handleUpdate,
  normalizedAssistantDescription,
}) {
  return (
    <div className="second-box">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "relative",
          marginBottom: "5px",
        }}
      >
        <label
          className={`configuration-text required ${showValidationErrors && validationErrors.name ? "error" : ""}`}
        >
          {tSelfAssist("assistant_name")}
        </label>
        <Info description={tSelfAssist("name_info")} />
      </div>

      <div
        className="input-with-counter"
        style={{ position: "relative", width: "100%" }}
      >
        <input
          type="text"
          id="assistantName"
          data-testid="assistantName"
          placeholder={tSelfAssist("assistant_name")}
          className={`configuration-input-field ${showValidationErrors && validationErrors.name ? "has-error" : ""} ${assistant.assistant.name.trim() ? "has-value" : ""}`}
          value={assistant.assistant.name}
          onChange={(e) => handleUpdate("assistant", "name", e.target.value)}
          maxLength={20}
          required
        />
        <span
          className={`char-counter ${(assistant.assistant?.name || "").length >= 20 ? "char-counter--warning" : ""}`}
          aria-live="polite"
        >
          {(assistant.assistant?.name || "").length}/20
        </span>
      </div>

      <div className="text-and-info">
        <label
          className={`configuration-text required ${showValidationErrors && validationErrors.description ? "error" : ""}`}
        >
          {tSelfAssist("assistant_description")}
        </label>
        <Info description={tSelfAssist("descripition_info")} />
      </div>

      <div
        className="textarea-with-counter"
        style={{ position: "relative", width: "100%" }}
      >
        <textarea
          id="assistantDescription"
          data-testid="assistantDescription"
          placeholder={tSelfAssist("assistant_description")}
          className={`configuration-textarea-field ${showValidationErrors && validationErrors.description ? "has-error" : ""} ${normalizedAssistantDescription.trim() ? "has-value" : ""}`}
          value={assistant.assistant.description}
          onChange={(e) =>
            handleUpdate("assistant", "description", e.target.value)
          }
          maxLength={60}
          required
        />
        <span
          className={`char-counter ${(normalizedAssistantDescription || "").length >= 60 ? "char-counter--warning" : ""}`}
          aria-live="polite"
        >
          {(normalizedAssistantDescription || "").length}/60
        </span>
      </div>
    </div>
  );
}
